import { HttpService, Query, QueryHandler, TaggedUrl, Tags } from '@skylab-shared/core';

export type KsefEnvironment = 'Demo' | 'Test' | 'Prod';

export interface KsefEnvironmentItem {
	readonly environment: KsefEnvironment;
}

export class KsefEnvironmentQuery extends Query<KsefEnvironmentItem> { }

export class KsefEnvironmentQueryHandlerBase implements QueryHandler<KsefEnvironmentQuery, KsefEnvironmentItem> {
	private static Url = TaggedUrl.join('user/ksef/environment', [Tags.Api]);

	public constructor(private readonly http: HttpService) { }

	public async handleAsync(_: KsefEnvironmentQuery): Promise<KsefEnvironmentItem> {
		const { data } = await this.http.get<KsefEnvironmentItem>(KsefEnvironmentQueryHandlerBase.Url);
		return data;
	}
}
